export enum SpinnerIconSize {
  SMALL,
  LARGE
}
